<template>
  <div class="grid bg-white">
    <div class="grid-title">
        <h4 class="heading semi-bold">Emails</h4>
    </div>
    <div class="grid-body">
      <vue-good-table
        styleClass="table table-bordered data-table"
        :rows="emails"
        :columns="columns"
        :isLoading.sync="isLoading"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'name'">
            <router-link
            :to="{ path: '/emails/' + props.row.id }"
              class="text-bold"
            >
              {{ props.row.name }}
            </router-link>
          </span>
          <span v-else-if="props.column.field == 'send_time'">
            {{ props.row.send_time }}
          </span>
          <span v-else-if="props.column.field == 'last_sent'">
            {{ props.row.statuses.length > 0 ? ezy.date(props.row.statuses[0].created_at) : 'N/A' }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>

import { VueGoodTable } from 'vue-good-table';

export default {
  mounted() {
    this.getEmails();
  },
  components: {
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      emails: [],
      columns: [
        {
          label: "Name",
          field: "name",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Send Time",
          field: "send_time",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Last Sent",
          field: "last_sent",
          tdClass: "text-left",
          thClass: "text-left",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    async getEmails(){
      this.isLoading = true;
      try {
        let res = await axios.get("/emails");
        this.emails = res.data.emails
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the developers"
          );
        }
      }
    }
  },
};
</script>
